import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Navbar } from '../Navbar';
import { Footer } from '../Footer';
import { HelpCircleIcon, BookOpenIcon, MessageCircleIcon, PhoneIcon, MailIcon, ChevronDownIcon, SearchIcon, ExternalLinkIcon, ArrowRightIcon, ChevronRightIcon } from 'lucide-react';
import { useTheme } from '../providers/ThemeProvider';
export const HelpSupportPage = () => {
  const {
    userType
  } = useAuth();
  const {
    theme
  } = useTheme();
  const darkMode = theme === 'dark';
  const navigate = useNavigate();
  // FAQ state for accordion
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  // FAQ toggle handler
  const toggleFaq = (index: number) => {
    setOpenFaq(openFaq === index ? null : index);
  };
  return <main className="pb-6" data-id="element-3568">
      <div className="max-w-7xl mx-auto px-4" data-id="element-3569">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-6" data-id="element-3570">
          <div className="mb-4 md:mb-0" data-id="element-3571">
            <h1 className="text-2xl sm:text-3xl font-bold" data-id="element-3572">Help & Support</h1>
          </div>
          <div className="relative" data-id="element-3573">
            <input type="text" placeholder="Search for help..." className={`pl-10 pr-4 py-2 rounded-lg ${darkMode ? 'bg-navy-900/50 border-navy-700 text-white placeholder-gray-400' : 'bg-white border-gray-300 text-gray-900 placeholder-gray-500'} border focus:ring-deep-pink focus:border-deep-pink`} data-id="element-3574" />
            <SearchIcon className={`absolute left-3 top-2.5 h-5 w-5 ${darkMode ? 'text-gray-400' : 'text-gray-500'}`} data-id="element-3575" />
          </div>
        </div>

        {/* Desktop: Centered single column layout */}
        {/* Mobile: Keep original stacked layout */}
        <div className="lg:flex lg:justify-center" data-id="element-3576">
          <div className="lg:max-w-4xl lg:w-full" data-id="element-3577">
            {/* Knowledge Base */}
            <div className={`${darkMode ? 'bg-navy-800/80' : 'bg-white'} rounded-xl shadow-sm p-6 mb-6`} data-id="element-3578">
              <div className="flex items-center mb-4" data-id="element-3579">
                <BookOpenIcon className="h-5 w-5 text-deep-pink mr-2" aria-hidden="true" data-id="element-3580" />
                <h2 className="text-xl font-serif font-semibold" data-id="element-3581">
                  Knowledge Base
                </h2>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-3582">
                <div onClick={() => navigate('/knowledge-base/getting-started')} className={`p-4 rounded-lg ${darkMode ? 'bg-navy-900/50' : 'bg-gray-50'} hover-elevate cursor-pointer`} data-id="element-3583">
                  <h3 className={`font-medium mb-2 ${darkMode ? 'text-white' : 'text-gray-900'}`} data-id="element-3584">
                    Getting Started
                  </h3>
                  <p className={`text-sm mb-3 ${darkMode ? 'text-gray-300' : 'text-gray-600'}`} data-id="element-3585">
                    Learn the basics of using MaestroConnect
                  </p>
                  <div className="flex justify-end" data-id="element-3586">
                    <ArrowRightIcon className={`h-5 w-5 ${darkMode ? 'text-deep-pink' : 'text-deep-pink'}`} data-id="element-3587" />
                  </div>
                </div>
                <div className={`p-4 rounded-lg ${darkMode ? 'bg-navy-900/50' : 'bg-gray-50'} hover-elevate cursor-pointer`} data-id="element-3588">
                  <h3 className={`font-medium mb-2 ${darkMode ? 'text-white' : 'text-gray-900'}`} data-id="element-3589">
                    Account & Billing
                  </h3>
                  <p className={`text-sm mb-3 ${darkMode ? 'text-gray-300' : 'text-gray-600'}`} data-id="element-3590">
                    Manage your subscription and payments
                  </p>
                  <div className="flex justify-end" data-id="element-3591">
                    <ArrowRightIcon className={`h-5 w-5 ${darkMode ? 'text-deep-pink' : 'text-deep-pink'}`} data-id="element-3592" />
                  </div>
                </div>
                <div onClick={() => navigate('/knowledge-base/scheduling-lessons')} className={`p-4 rounded-lg ${darkMode ? 'bg-navy-900/50' : 'bg-gray-50'} hover-elevate cursor-pointer`} data-id="element-3593">
                  <h3 className={`font-medium mb-2 ${darkMode ? 'text-white' : 'text-gray-900'}`} data-id="element-3594">
                    Scheduling Lessons
                  </h3>
                  <p className={`text-sm mb-3 ${darkMode ? 'text-gray-300' : 'text-gray-600'}`} data-id="element-3595">
                    Learn how to schedule and manage lessons
                  </p>
                  <div className="flex justify-end" data-id="element-3596">
                    <ArrowRightIcon className={`h-5 w-5 ${darkMode ? 'text-deep-pink' : 'text-deep-pink'}`} data-id="element-3597" />
                  </div>
                </div>
                <div onClick={() => navigate('/knowledge-base/virtual-classroom')} className={`p-4 rounded-lg ${darkMode ? 'bg-navy-900/50' : 'bg-gray-50'} hover-elevate cursor-pointer`} data-id="element-3598">
                  <h3 className={`font-medium mb-2 ${darkMode ? 'text-white' : 'text-gray-900'}`} data-id="element-3599">
                    Virtual Classroom
                  </h3>
                  <p className={`text-sm mb-3 ${darkMode ? 'text-gray-300' : 'text-gray-600'}`} data-id="element-3600">
                    How to use our online teaching platform
                  </p>
                  <div className="flex justify-end" data-id="element-3601">
                    <ArrowRightIcon className={`h-5 w-5 ${darkMode ? 'text-deep-pink' : 'text-deep-pink'}`} data-id="element-3602" />
                  </div>
                </div>
              </div>
            </div>

            {/* FAQs */}
            <div className={`${darkMode ? 'bg-navy-800/80' : 'bg-white'} rounded-xl shadow-sm p-6 mb-6`} data-id="element-3603">
              <h3 className={`text-lg font-medium mb-4 ${darkMode ? 'text-white' : 'text-gray-900'}`} data-id="element-3604">
                Frequently Asked Questions
              </h3>
              <div className="space-y-3" data-id="element-3605">
                {[{
                question: 'How do I change my password?',
                answer: 'You can change your password by going to Account Security in your settings. Click on the "Change Password" button and follow the instructions.'
              }, {
                question: 'How do I cancel my subscription?',
                answer: 'To cancel your subscription, go to Billing & Payouts, then select "Manage Subscription" and follow the cancellation process.'
              }, {
                question: 'Can I get a refund?',
                answer: 'Refund policies vary depending on your subscription type. Please contact our support team for specific information about your situation.'
              }, {
                question: 'Do I need to pay to use Maestro Connect?',
                answer: "Maestro Connect may introduce paid plans in the future. You'll always be notified before any billing is required."
              }, {
                question: 'Can I use Maestro Connect as a student?',
                answer: 'Yes. Maestro Connect supports both teachers and students, with each having a dedicated account experience.'
              }, {
                question: 'Is Maestro Connect available on mobile?',
                answer: 'Yes. Maestro Connect is designed to work on desktop and mobile devices through a responsive web interface.'
              }, {
                question: 'What image sizes should I use for my profile banner and photo?',
                answer: "To ensure your profile looks professional across all devices, please use the recommended sizes below:\n\nProfile Banner (Header Image):\n• Size: 2400 × 600 pixels\n• Aspect Ratio: 4:1\n• File Format: JPG or PNG\n• Keep important content in the center and top area\n• Avoid the bottom-left corner, which is covered by your profile photo\n\nProfile Photo (Avatar):\n• Size: 400 × 400 pixels\n• Aspect Ratio: 1:1 (square)\n• Your photo will appear as a circle, so keep your face centered\n\nDesign Tip: If you're using Canva, create a custom design with these exact dimensions to avoid cropping or distortion."
              }, {
                question: 'How do I contact support?',
                answer: 'You can contact support anytime by using the email option in the Help & Support section. We typically respond within 24 hours.'
              }].map((faq, index) => <div key={index} className={`rounded-lg overflow-hidden ${darkMode ? 'bg-navy-900/50' : 'bg-gray-50'} hover-elevate`} data-id="element-3606">
                    <button className={`w-full px-4 py-3 text-left flex justify-between items-center`} onClick={() => toggleFaq(index)} data-id="element-3607">
                      <span className={`font-medium ${darkMode ? 'text-white' : 'text-gray-900'}`} data-id="element-3608">
                        {faq.question}
                      </span>
                      <ChevronDownIcon className={`h-5 w-5 ${darkMode ? 'text-gray-400' : 'text-gray-500'} transition-transform ${openFaq === index ? 'transform rotate-180' : ''}`} data-id="element-3609" />
                    </button>
                    {openFaq === index && <div className={`px-4 py-3 ${darkMode ? 'border-t border-navy-700' : 'border-t border-gray-200'}`} data-id="element-3610">
                        <p className={`text-sm ${darkMode ? 'text-gray-300' : 'text-gray-600'} whitespace-pre-line`} data-id="element-3611">
                          {faq.answer}
                        </p>
                      </div>}
                  </div>)}
              </div>
            </div>

            {/* Contact Support Section - Now below FAQ */}
            <div className={`${darkMode ? 'bg-navy-800/80' : 'bg-white'} rounded-xl shadow-sm p-6`} data-id="element-3612">
              <h2 className={`text-xl font-bold mb-4 ${darkMode ? 'text-white' : 'text-gray-900'}`} data-id="element-3613">
                Contact Support
              </h2>
              {/* Email Support */}
              <div className={`p-4 rounded-lg ${darkMode ? 'bg-navy-900/50' : 'bg-gray-50'} flex items-start hover-elevate`} data-id="element-3614">
                <MailIcon className={`h-5 w-5 text-[#10B981] mr-3 mt-0.5 flex-shrink-0`} data-id="element-3615" />
                <div data-id="element-3616">
                  <h3 className={`font-medium mb-1 ${darkMode ? 'text-white' : 'text-gray-900'}`} data-id="element-3617">
                    Email Support
                  </h3>
                  <p className={`text-sm mb-2 ${darkMode ? 'text-gray-300' : 'text-gray-600'}`} data-id="element-3618">
                    We'll respond within 24 hours
                  </p>
                  <a href="mailto:support@maestroconnect.com" className="inline-flex items-center px-3 py-1.5 rounded-lg text-sm border-2 border-[#10B981] text-[#10B981] hover:bg-[#10B981]/10 transition-colors" data-id="element-3619">
                    Send Email
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>;
};